///linehaul-manifests/terminal/{terminalNumber}/summary-counts
import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "app/data/common/queryKeys";
import { apiQueryAdapter } from "app/data/apiQueryAdapter";
import { useSelector } from "react-redux";
import { userSelector } from "slices/user/userSlice";

export const useInboundFreightCounts = (manifest?: string, originCity?: string, status?: string, arrivalDate?: string) => {
  const userState = useSelector(userSelector);

  const { isFetching, isLoading, data, error } =
    useQuery<any[]>({
      queryKey: [QUERY_KEYS.INBOUND_FREIGHT_COUNTS, userState.activeTerminal?.id,
        manifest, originCity, arrivalDate, status],
      queryFn: async () => {
        let params = {};
        if (manifest) {
          params = { manifest };
        }
        if (originCity) {
          params = { ...params, originCity };
        }
        if (arrivalDate) {
          params = { ...params, arrivalDate };
        }
        if (status) {
          params = { ...params, status };
        }
        const response = await apiQueryAdapter.query<any[]>(`/linehaul-manifests/terminal/${userState.activeTerminal?.id}/summary-counts`,
          "GET",
          { params }
        );

        return response.data;
      },
    })
  return { isFetching, isLoading, data, error };
}